import groupedByYear from "../../generated/talks.json";

export default groupedByYear;
